// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyProfileService_container__2fIw4","panel":"CompanyProfileService_panel__3X-hQ","sending":"CompanyProfileService_sending__2sllA"};